"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __importDefault(require("date-fns/format"));
var sk_1 = __importDefault(require("date-fns/locale/sk"));
exports.__ = function (toTranslate) {
    return toTranslate;
};
exports.formatDate = function (date, formatStr) {
    return format_1.default(date, formatStr, {
        locale: sk_1.default,
    });
};
exports.emptyFn = function () { };
exports.debounce = function (func, timeout) {
    var timer;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = setTimeout(function () {
            func.apply(void 0, args);
        }, timeout);
    };
};
